import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCI: CultureInfo = {
  name: 'fr-CI',
  displayName: 'French (Côte d’Ivoire)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CI',
  parent: CultureInfoFr
};
